export default __webpack_public_path__ + "static/media/bathroom2-afterA-2048w.2bcb1992.webp";